import onReady from '@/scripts/modules/on-ready';
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

onReady( () => {
	const carousels = document.querySelectorAll( '.eventsCarousel' );

	if ( 0 < carousels.length ) {
		Swiper.use( [ Navigation, Scrollbar ] );
		carousels.forEach( ( carousel ) => {
			new Swiper( carousel, {
				slidesPerView: 1.2,
				spaceBetween: 24,
				navigation: {
					prevEl: carousel.querySelector( '.swiper-button-prev' ),
					nextEl: carousel.querySelector( '.swiper-button-next' ),
				},
				breakpoints: {
					600: {
						slidesPerView: 2.4,
					},
					768: {
						slidesPerView: 3,
					},
					1060: {
						slidesPerView: 'auto',
					},
				},
			} );
		} );
	}
} );
